// Queue and LAN parties: two tabs of one page, as classic MatchmakingPage / MatchmakingLanPage
export default [
  {
    path: '/v5/matchmaking',
    name: 'V5Matchmaking',
    component: () => import('./MatchmakingPage.vue'),
  },
  {
    path: '/v5/matchmaking/lan',
    name: 'V5MatchmakingLan',
    component: () => import('./MatchmakingPage.vue'),
  },
];
